import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "You have permission to suck",
  "description": "",
  "published": "2018-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/permission-suck/swizec/8463"],
  "categories": "Personal, Thoughts, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It's been 40 days since I published `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=IvR-vxTYhKQ&index=30&list=PLF8WgaD4xmjWuh7FTYTealxehOuNor_2S"
      }}>{`my last daily video`}</a>{`.`}</p>
    <p>{`26 days since I said, `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/learned-recording-educational-video-every-day/swizec/8405"
      }}>{`”Ok. getting back to it now.”`}</a></p>
    <p>{`Last night, I finally made a new one. After 50 minutes of procrastination, it took 15 minutes to produce.`}</p>
    <p>{`But I didn't publish. Yet.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`You’re harder on yourself than your viewers are. Just make a single update video <2 mins in length. A small win will give you the inertia to start again. If that doesn’t help, then just shut it down and don’t do daily videos again for a while—because that’s ok, too.`}</p>{`— Ken Wallace (@boaticus) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/boaticus/status/1009067338241576960"
      }}>{`June 19, 2018`}</a></blockquote>
    <p>{`It's all got to do with `}<a parentName="p" {...{
        "href": "https://dcgross.com/accomplish-dread-tasks/"
      }}>{`the psychology of daunting tasks`}</a>{` and the vicious cycle that creates.`}</p>
    <p>{`Here's how it works for me 👇`}</p>
    <p>{`You do something creative every day. You're having a blast. You make a video or a blog post or a piece of code or a tiny open source library. Create create create. Write write write. Publish publish publish.`}</p>
    <p><img parentName="p" {...{
        "src": "/75b52594f95168a77272be5d93c858ce/media-UogSmj4xDjQZO-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`The feedback loop is tremendous. The more you create, the more creative you become. Every idea breeds five new ideas.`}</p>
    <p>{`Explore a concept, find five new concepts. I should write about that and that, and oh that too! Someone asked me a question, amazing. Ooh, that tweet was interesting, I can do so much with that.`}</p>
    <p>{`You get feedback, you get help, you get questions. The results compound and soon you have more ideas than you have time.`}</p>
    <p>{`And then you stumble.`}</p>
    <p><img parentName="p" {...{
        "src": "/a73e8a5cfbd9fee399bb37cbe69cd93b/media-rvasIXgTtFkze-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`You have a conference. Or you get a little tired. A little burnt out. Your girlfriend says you're an ass and should spend time with her, too. Or your creative practice leads to some cool opportunities and you have to say to yourself `}<em parentName="p">{`"Well fuck, this is such a cool opportunity, I can't not do this! But then I won't have time to create every day. But I have to do this. Isn't this what I've been working towards this whole time? I gotta.”`}</em></p>
    <p>{`You miss a day. No biggie.`}</p>
    <p>{`You miss two days. Okay.`}</p>
    <p>{`You miss 3 days.`}</p>
    <p>{`Ooof, now you need something worthy of 3 days to come back with. But what?`}</p>
    <p>{`You don't know what. 3 more days pass.`}</p>
    <p>{`Shit. Now it needs to be awesome enough for 6 days!`}</p>
    <p>{`That's intimidating. What could possibly be good enough to warrant a 6 day hiatus?`}</p>
    <p>{`6 more days pass.`}</p>
    <p>{`Damn it!`}</p>
    <p><img parentName="p" {...{
        "src": "/0326aa84f2dc2c316f6ae29f3fbed9f1/media-WVqfM4G3o0W64-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Now you're stuck in a loop. The more time passes, the more pressure you feel that the next thing you publish has to be really, really good. The harder you are on yourself, the harder it becomes to do anything.`}</p>
    <p>{`That pressure to create something good is the killer. It guarantees you will never create anything at all.`}</p>
    <p>{`And without creating, you won't have ideas. You won't have the compounding effect of ideas making more ideas. You'll just have the compounding effect of pressure and more pressure bringing you down.`}</p>
    <p>{`The only solution is to create. Force yourself to do something tiny. Stupid. Simple. It doesn’t have to be big or awesome. You're just breaking the cycle.`}</p>
    <p>{`And you know what they say about creative things that don't spread, don't you? They don't spread.`}</p>
    <p>{`That's a blessing. An idea or video or blogpost or article or book that doesn't spread is an idea, video, blogpost, or article that nobody saw.`}</p>
    <p>{`You have permission to suck. Nobody's gonna see it anyway. 😉`}</p>
    <h2 {...{
      "id": "heres-the-point"
    }}>{`Here’s the point…`}</h2>
    <p>{`Don't be like that band who makes a great album, goes on tour, and forgets to make the next album. Too busy being successful.`}</p>
    <p>{`Or that author who writes a book, makes some sales, and feels too much pressure to write the next hit.`}</p>
    <p>{`Or that maker who launches an app, gets some customers, but "not enough", and spends 2 years polishing and perfecting the next one only to find out they're solving the wrong problem.`}</p>
    <p>{`Stephen King asks `}<a parentName="p" {...{
        "href": "https://www.nytimes.com/2015/08/31/opinion/stephen-king-can-a-novelist-be-too-productive.html"
      }}>{`Can a novelist be too productive?`}</a>{`. Maybe. Probably not.`}</p>
    <lite-youtube {...{
      "videoid": "xR7XMkjDGw0",
      "videostartat": "0"
    }}></lite-youtube>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      